"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const CheckCircleRounded_1 = __importDefault(require("@mui/icons-material/CheckCircleRounded"));
const core_1 = require("companion-app-components/utils/core");
const nps_1 = require("companion-app-components/flux/nps");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const auth_1 = require("companion-app-components/flux/auth");
const QButton_1 = __importDefault(require("components/QButton"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const styles = () => ({
    dialogBackground: {
        backgroundColor: 'unset',
    },
});
exports.styles = styles;
const useStyles = (0, mui_1.makeStyles)()(exports.styles);
const NPSSurveyDialog = ({ onClose, dialogId, title }) => {
    const [feedback, setFeedback] = (0, react_1.useState)('');
    const [score, setScore] = (0, react_1.useState)(undefined);
    const [hoverScore, setHoverScore] = (0, react_1.useState)(undefined);
    const [thankYou, setThankYou] = (0, react_1.useState)(false);
    const { classes } = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isWebFirstDataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getIsWebfirstDataset);
    (0, react_use_1.useEffectOnce)(() => core_1.tracker.track(core_1.tracker.events.nps, { status: 'start' }));
    const handleClose = (event, reason) => {
        let surveyResult;
        if (!thankYou) {
            dispatch(auth_1.authActions.updateAuth({ surveyRequested: false }));
            core_1.tracker.track(core_1.tracker.events.nps, {
                status: 'response',
                feedback: feedback.length > 0 ? feedback : undefined,
                rating: score,
            });
            if (reason === 'OK_BUTTON') {
                surveyResult = 'COMPLETED';
            }
            else if (!score) {
                surveyResult = 'ABANDONED';
            }
            else {
                surveyResult = 'CANCELLED';
            }
            dispatch(nps_1.npsActions.postNPSSurveyResultAction({ surveyResult }));
        }
        if (surveyResult === 'COMPLETED') {
            setThankYou(true);
            setTimeout(() => {
                onClose === null || onClose === void 0 ? void 0 : onClose(event);
                dispatch(root_ui_1.rootUiActions.removeDialog(dialogId));
            }, 2500);
        }
        else {
            onClose === null || onClose === void 0 ? void 0 : onClose(event);
            dispatch(root_ui_1.rootUiActions.removeDialog(dialogId));
        }
    };
    const renderThankYou = () => (<DialogContent_1.default>
      <CheckCircleRounded_1.default color="primary" style={{
            width: 64,
            height: 64,
            marginTop: 24,
            marginBottom: 24,
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}/>
      <Typography_1.default variant="h6" align="center" style={{
            marginBottom: 24,
        }}>
        Thank you.
      </Typography_1.default>
      <Typography_1.default variant="subtitle1" align="center">
        Your feedback helps us discover new opportunities to improve Quicken and make sure you have the best possible
        experience.
      </Typography_1.default>
    </DialogContent_1.default>);
    const renderNPS = () => {
        let message;
        if (isWebFirstDataset) {
            message = 'How likely are you to recommend Quicken to a friend or colleague?'; // Quicken Web First
        }
        else {
            message = 'How likely are you to recommend Quicken on the Web to a friend or colleague who uses Quicken?'; // Quicken
        }
        return (<>
        <DialogTitle_1.default className={classes.dialogBackground}>
          {message}
        </DialogTitle_1.default>
        <DialogContent_1.default>
          <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
            }}>
            {[...Array(11).keys()].map((scoreMapped) => (<IconButton_1.default style={{
                    border: scoreMapped === score ? 'solid 2px' : 'solid 1px',
                    width: 32,
                    height: 32,
                    fontSize: 14,
                }} key={scoreMapped} id={`nps-score-${scoreMapped}`} aria-label={String(scoreMapped)} color={scoreMapped === hoverScore || scoreMapped === score ? 'primary' : 'default'} onClick={() => setScore(scoreMapped)} onMouseOver={() => setHoverScore(scoreMapped)} onFocus={() => setHoverScore(scoreMapped)} onMouseOut={() => setHoverScore(undefined)} onBlur={() => setHoverScore(undefined)} size="large">
                <div style={{ position: 'absolute' }}>
                  {scoreMapped}
                </div>
              </IconButton_1.default>))}
          </div>

          <Typography_1.default variant="caption" style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                marginTop: 8,
            }}>
            <span>
              Not likely at all
            </span>
            <span>
              Extremely likely
            </span>
          </Typography_1.default>

          <br />

          {score !== undefined &&
                <TextField_1.default autoFocus label="What is the primary reason for your score?" id="nps-feedback" aria-label="What is the primary reason for your score?" multiline value={feedback} onChange={(event) => setFeedback(event.target.value)} margin="normal" fullWidth inputProps={{ maxLength: 255 }} helperText={`You can enter up to 255 characters (${255 - feedback.length} remaining).`} rows="4" maxRows="4" variant="outlined"/>}
        </DialogContent_1.default>
        {score !== undefined &&
                <DialogActions_1.default>
            <QButton_1.default id="nps-send" aria-label="Send" onClick={(event) => handleClose(event, 'OK_BUTTON')}>
              Submit
            </QButton_1.default>
          </DialogActions_1.default>}
      </>);
    };
    return (<StdDialog_1.default open onClose={(e) => !thankYou ? handleClose(e) : null} title={title} sharedcomponentid={'DIALOG_TYPE_NPS_SURVEY'} showCloseButton={!thankYou}>
      {thankYou ? renderThankYou() : renderNPS()}
    </StdDialog_1.default>);
};
exports.default = NPSSurveyDialog;
